import { useEffect, useRef, useState } from "react";
import Loader from "./globals/elements/loader";
import ScrollToTop from "./globals/scroll-to-top";
import RootLayout from "./layouts/root-layout";
import Arr from './utils/array'
import {
  getLayoutInfo,
  getBreadcrumbList,
  getTopmenuCategoryList
} from './utils/func'

function App() {

  const [isLoading, setLoading] = useState(true);

  const [topmenuList,setTopmenuList] = useState([])

  const [layoutInfo,setLayoutInfo] = useState({
    site_name: "",
    company_name: "",
    beian: "",
    contact_number:"",
    keywords: "",
    logo: "",
    logo_small: "",
    favicon: "",
    description: "",
    company_address:"",
    description: "",
    admin_phone: "",
    email: "",
    formspree:""
})

  const [breadcrumbList,setBreadcrumbList] = useState([])

  useEffect(() => {
      loadLayoutInfo();
      loadTopmenuList()
      loadBreadcrumbs()
  }, []);


  function loadLayoutInfo() {

    getLayoutInfo().then(result => {
      setLayoutInfo(result[0])
    }).catch(err => {
    }).finally(() => {
      setLoading(false)
    })
  }

  function loadTopmenuList() {
    getTopmenuCategoryList().then(result => {
      
      // result 转到包含children的tree结构
      const tree = Arr.toTree(result);
      setTopmenuList(tree)
    }).catch(err => {

    })
  }

  function loadBreadcrumbs() {
  
    getBreadcrumbList().then(result => {
      console.log("68 breadcrumb resul is --------------", result)
      setBreadcrumbList(result)
    }).catch(err => {
      console.log("71 breadcrumb is error --------------", err)
    })
  }

  return (
    <>
      {isLoading && <Loader />}
      <ScrollToTop />
   
      {/*  */}
      <RootLayout 
        layoutInfo={layoutInfo}
        breadcrumbList={breadcrumbList}
        topmenuList={topmenuList}
      />
    </>
  );
}

export default App;
